import type { Ref } from 'vue'

export const useChannel = (defaultValue?: number): Ref<number> => {
  return useRouteFilter('channel', defaultValue)
}
